module.exports = __webpack_public_path__ + "static/img/KE.084c70af.png";